import { createSelector } from 'reselect';

const search = state => state.events.search;

export const searchOpenSelector = createSelector(search, search => search.open);
export const searchQuerySelector = createSelector(search, search => search.query);
export const searchResultsSelector = createSelector(search, search => search.results);
export const isFetchingSelector = createSelector(search, search => search.fetching);
